import * as React from 'react';
import { createRoot } from 'react-dom/client';

import { BookprocessStep } from './components/BookprocessStep';
import { BookprocessSelect } from './components/BookprocessSelect';
import {
    sendTagManagerEvent,
    createPurchasePayload,
    createUserDataPayload,
} from './components/gtagEvent';
import { bookingInfo } from './components/bookingInfoInterface';
import { StrictMode } from 'react';
import { normalizePrefillData } from './prefill';

const bookprocessElements = document.querySelectorAll('.bookprocess') as NodeListOf<HTMLElement>;
if (bookprocessElements.length === 0) {
    const bookprocessIdElement = document.getElementById('bookprocess'); // fallback
    if (bookprocessIdElement) {
        createBookprocess(bookprocessIdElement);
        bookprocessIdElement.classList.add('bookprocess');
    }
}
for (let bookprocessElement of bookprocessElements) {
    createBookprocess(bookprocessElement);
}

function createBookprocess(bookprocessElement: HTMLElement) {
    const bookProcessId = bookprocessElement.dataset.id;
    const baseUrl = bookprocessElement.dataset.url || '';
    const firstWidgetValue = bookprocessElement.dataset.firstWidgetValue || null;
    const firstWidgetQuantity = bookprocessElement.dataset.firstWidgetQuantity || null;

    const urlParams = new URLSearchParams(window.location.search);
    const prefillFromUrl = urlParams.get('prefill');
    const prefillFromAttribute = bookprocessElement.dataset.prefill;

    // Booking Experts embeds this page in an iframe and appends the reservation
    // page as `back_url`. We forward it so the guest is sent back to Booking
    // Experts when the booking finishes (the server validates the host).
    const returnUrl = urlParams.get('back_url') || undefined;

    let prefillConfig = normalizePrefillData(prefillFromAttribute);

    if (prefillFromUrl) {
        try {
            const decodedPrefill = decodeURIComponent(atob(prefillFromUrl));
            const urlPrefillConfig = normalizePrefillData(decodedPrefill);
            prefillConfig = new Map([...prefillConfig, ...urlPrefillConfig]);
        } catch (e) {
            console.warn(
                '[Recras Bookprocess] Invalid prefill URL parameter: Unable to decode base64'
            );
        }
    }

    const root = createRoot(bookprocessElement!);
    if (bookProcessId) {
        let selfURL = `${baseUrl}/api2/bookprocesses/book/${bookProcessId}`;
        let bookProcessUrl = new URL(selfURL, window.location.toString());

        root.render(
            <StrictMode>
                <BookprocessStep
                    selfURL={bookProcessUrl}
                    firstWidgetValue={firstWidgetValue}
                    firstWidgetQuantity={firstWidgetQuantity}
                    prefillConfig={prefillConfig}
                    returnUrl={returnUrl}
                />
            </StrictMode>
        );
    } else {
        root.render(<BookprocessSelect />);
    }
}

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const infoUrl = urlParams.get('infoUrl');

if (infoUrl) {
    fetch(infoUrl)
        .then(resp => {
            return resp.json();
        })
        .then(resp => {
            let info = resp.info as bookingInfo;
            if (info.bookingStatus === 'definitief') {
                sendTagManagerEvent(
                    'purchase',
                    createPurchasePayload(info),
                    createUserDataPayload(info)
                );
            } else if (
                info.bookingStatus === 'reservering' ||
                info.bookingStatus === 'optie' ||
                info.bookingStatus === 'interesse'
            ) {
                sendTagManagerEvent(
                    'quotation',
                    createPurchasePayload(info),
                    createUserDataPayload(info)
                );
            }
        });
}
